import { render } from "./ColleagueDepartmentDetails.vue?vue&type=template&id=7548c228&scoped=true"
import script from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"
export * from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"

import "./ColleagueDepartmentDetails.vue?vue&type=style&index=0&id=7548c228&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7548c228"]])

export default __exports__